// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    background-color: #a7c898;
    padding: 30px 20px;
    border-top: 1px solid #e9ecef;
    height: auto;
    position: relative;
    transform: translateY(0);
    display: flex;
    justify-content: center;
}

.main {
    display: flex;
    flex-direction: row;
    justify-content: space-between; /* 좌우 정렬 */
    align-items: center;
    text-align: left;
    width: 60%; /* 최대 너비 설정 */
    max-width: 1200px; /* 원하는 최대 크기 */
    margin: 0 auto;
    color: #e2e6ea;
}

.mainleft {
    display: flex;
    flex-direction: column;
    /*padding-left: 20%;*/
    align-items: flex-start; /* 왼쪽 정렬 */
    text-align: left;
    margin-right: auto; /* 왼쪽 정렬 유지 */
}

.mainright {
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* 오른쪽 정렬 */
    text-align: right;
    /*padding-right: 20%;*/
    /*margin-left: auto; !* 오른쪽 정렬 유지 *!*/
}

.main_logo {
    color: white;
    display: flex;
    flex-direction: column;
}

.column {
    margin: 10px 0;
    display: flex;
    flex-direction: column;
}

.title {
    font-size: 24px;
    font-weight: bold;
    margin: 20px;
}

.mainleft img {
    height: 100px;
}

.info {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: 10px 0;

}

.infotext {
    font-size: 14px;
    color: #f8f9fa;
}

.infotext a {
    color: #f8f9fa;
    text-decoration: none;
}
.developer a{
    color: #f8f9fa;
    text-decoration: none;
}

.address, .developer, .copyright {
    font-size: 12px;
    text-align: left;
}

@media (max-width: 768px) {
    .main {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .mainleft {
        margin: 0;
        /*padding: 0;*/
    }

    .mainright {
        align-items: center;
        text-align: center;
    }

    .info {
        flex-direction: column;
    }

    .infotext, .address, .developer, .copyright {
        font-size: 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/styles.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B,EAAE,UAAU;IAC1C,mBAAmB;IACnB,gBAAgB;IAChB,UAAU,EAAE,aAAa;IACzB,iBAAiB,EAAE,cAAc;IACjC,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB,EAAE,UAAU;IACnC,gBAAgB;IAChB,kBAAkB,EAAE,aAAa;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,WAAW;IACpC,iBAAiB;IACjB,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;;AAElB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,SAAS;QACT,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".footer {\n    background-color: #a7c898;\n    padding: 30px 20px;\n    border-top: 1px solid #e9ecef;\n    height: auto;\n    position: relative;\n    transform: translateY(0);\n    display: flex;\n    justify-content: center;\n}\n\n.main {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between; /* 좌우 정렬 */\n    align-items: center;\n    text-align: left;\n    width: 60%; /* 최대 너비 설정 */\n    max-width: 1200px; /* 원하는 최대 크기 */\n    margin: 0 auto;\n    color: #e2e6ea;\n}\n\n.mainleft {\n    display: flex;\n    flex-direction: column;\n    /*padding-left: 20%;*/\n    align-items: flex-start; /* 왼쪽 정렬 */\n    text-align: left;\n    margin-right: auto; /* 왼쪽 정렬 유지 */\n}\n\n.mainright {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start; /* 오른쪽 정렬 */\n    text-align: right;\n    /*padding-right: 20%;*/\n    /*margin-left: auto; !* 오른쪽 정렬 유지 *!*/\n}\n\n.main_logo {\n    color: white;\n    display: flex;\n    flex-direction: column;\n}\n\n.column {\n    margin: 10px 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.title {\n    font-size: 24px;\n    font-weight: bold;\n    margin: 20px;\n}\n\n.mainleft img {\n    height: 100px;\n}\n\n.info {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    margin: 10px 0;\n\n}\n\n.infotext {\n    font-size: 14px;\n    color: #f8f9fa;\n}\n\n.infotext a {\n    color: #f8f9fa;\n    text-decoration: none;\n}\n.developer a{\n    color: #f8f9fa;\n    text-decoration: none;\n}\n\n.address, .developer, .copyright {\n    font-size: 12px;\n    text-align: left;\n}\n\n@media (max-width: 768px) {\n    .main {\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n    }\n\n    .mainleft {\n        margin: 0;\n        /*padding: 0;*/\n    }\n\n    .mainright {\n        align-items: center;\n        text-align: center;\n    }\n\n    .info {\n        flex-direction: column;\n    }\n\n    .infotext, .address, .developer, .copyright {\n        font-size: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
